import React from "react";
import artistGif from "../../../../assets/images/artist.gif";
import { artistGenresList } from "../../../../utils/genres";

const ArtistCard = ({ artist, onClick }) => {
  if (!artist) return null;

  const genres = artistGenresList(artist);
  const shown = genres.slice(0, 2);
  const more = genres.length - shown.length;

  return (
    <div className="artist-card" onClick={onClick}>
      <div className="artist-photo">
        <img
          src={artist.artist_pic || artistGif}
          alt={artist.stage_name || "Artist"}
          onError={(e) => {
            e.currentTarget.src = artistGif;
          }}
        />
      </div>
      <div className="artist-info">
        <h3 className="artist-name">{artist.stage_name || "Unknown Artist"}</h3>
        {artist.hometown && (
          <p className="artist-location">📍 {artist.hometown}</p>
        )}
        {genres.length > 0 && (
          <p className="artist-genre">
            {shown.join(" · ")}
            {more > 0 ? ` +${more}` : ""}
          </p>
        )}
      </div>
    </div>
  );
};

export default ArtistCard;
